<template>
  <div class="coin" :data-cy="dataCy">
    {{ faceValue }}
    <slot name="icon"></slot>
  </div>
</template>

<script>
  export default {
    name: 'Coin',

    props: {
      faceValue: Number,
      dataCy: {
        type: String,
        default: 'coin',
      },
    },
  };
</script>
